import React from "react";
import styled from "styled-components";

const SectionWrapper = styled.section`
  padding: 50px 20px;
  background-color: #f7f7f7;
  text-align: center;
`;

const SectionHeader = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 20px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const VideoWrapper = styled.div`
  flex: 1;
  max-width: 500px;

  iframe {
    width: 100%;
    height: 280px;
    border: none;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    height: auto;

    iframe {
      height: 200px;
    }
  }
`;

const TextContent = styled.div`
  flex: 1;
  text-align: left;

  h3 {
    font-size: 1.8rem;
    margin-bottom: 15px;
    color: var(--hhb-primary); /* Use Habitat's primary color */
  }

  p {
    font-size: 1rem;
    line-height: 1.8;
    color: #333;
    margin-bottom: 15px;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const HistorySection = () => (
  <SectionWrapper>
    <SectionHeader>Our History</SectionHeader>
    <ContentWrapper>
      <VideoWrapper>
        <iframe
          src="https://www.youtube.com/embed/BN9PlXH-rss"
          title="Habitat Buffalo History"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </VideoWrapper>
      <TextContent>
        <h3>Building Homes, Communities, and Hope</h3>
        <p>
          Since 1985, Habitat for Humanity Buffalo has worked tirelessly to
          transform lives and neighborhoods, building more than 400 homes for
          families in need of safe, affordable housing. Guided by our mission
          and supported by volunteers, donors, and community partners, we’ve
          been a beacon of hope for countless families across Western New York.
        </p>
        <p>
          Our work doesn’t just provide homes—it builds stability and fosters
          resilience in our communities. Through initiatives like the #400in40
          campaign, we continue to expand our impact, empowering families to
          achieve their dreams of homeownership.
        </p>
        <p>
          Together, we’re creating a Buffalo where everyone has a decent place
          to live. Join us as we honor our legacy and build a brighter future
          for generations to come.
        </p>
      </TextContent>
    </ContentWrapper>
  </SectionWrapper>
);

export default HistorySection;
